export default "__VITE_ASSET__CfS0HIsF__"